// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__1QZ-W","messages":"Chat_messages__1W2oO","dateDivider":"Chat_dateDivider__30VcN"};